import { hasCapability, type User } from "../base";

export const estimate = {
  forceCreate: (user: User) => hasCapability(user, "estimate.forceCreate"),
  create: (user: User) => hasCapability(user, "estimate.create"),
};
